import { render, staticRenderFns } from "./DialogAddEditEventLive.vue?vue&type=template&id=77a8cd28&scoped=true"
import script from "./DialogAddEditEventLive.js?vue&type=script&lang=js&external"
export * from "./DialogAddEditEventLive.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a8cd28",
  null
  
)

export default component.exports